import React from 'react';
import { FormattedDate } from 'react-intl';

interface Props {
  date: React.ComponentProps<typeof FormattedDate>['value'];
}

const AccountDate: React.FC<Props> = ({ date }) => (
  <FormattedDate
    value={date}
    year="numeric"
    month="2-digit"
    day="2-digit"
    hour="2-digit"
    minute="2-digit"
  />
);

export default AccountDate;
